import { useState, useCallback } from "react"

export const useExperienceFilters = (initialTab = "published") => {
  const [activeTab, setActiveTab] = useState("all")
  const [activeListingTab, setActiveListingTab] = useState(initialTab)
  const [selectedType, setSelectedType] = useState("")
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false)

  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab)
  }, [])

  const handleListingTabChange = useCallback((tab) => {
    setActiveListingTab(tab)
    setSelectedType("")
  }, [])

  const handleFilterIconClick = useCallback(() => {
    setIsFilterDropdownOpen((prev) => !prev)
  }, [])

  const handleCloseFilterDropdown = useCallback(() => {
    setIsFilterDropdownOpen(false)
  }, [])

  return {
    activeTab,
    activeListingTab,
    selectedType,
    isFilterDropdownOpen,
    handleTabChange,
    handleListingTabChange,
    setSelectedType,
    handleFilterIconClick,
    handleCloseFilterDropdown
  }
}
